import { useMediaQuery } from '@material-ui/core';
import React from 'react';
import { MUI_DESKTOP_BREAKPOINT } from 'src/scripts/utils/constants';
import SearchFormWrapper from '../Search/SearchFormWrapper';

function SearchMobileNav() {
  const isDesktop = useMediaQuery(MUI_DESKTOP_BREAKPOINT, { noSsr: true });
  if (isDesktop) return null;
  return (
    <div id="MobileSearchNavMenu" style={{ height: '100%', scrollPaddingTop: '100vh' }}>
      <span className="l1-searchbar" style={{ display: 'inherit' }}>
        <div className="SearchBarMobile">
          <SearchFormWrapper />
        </div>
      </span>
    </div>
  );
}

export default SearchMobileNav;
